import { createAsyncThunk, createSlice, ActionReducerMapBuilder } from '@reduxjs/toolkit';
import axios from 'axios';
import store from 'src/services/redux/app/Store';
import { IProductReviews } from '../../../../interfaces';

const VENDOR_MC_URL = `${process.env.REACT_APP_API_PIM_URL}`;

interface IState {
  data: IProductReviews;
  loading: boolean;
  done: boolean;
  showError: boolean;
  error: any;
}

const initialState: IState = {
  data: {} as IProductReviews,
  loading: false,
  done: false,
  error: null,
  showError: false,
};

export const productReviews = createAsyncThunk('productReviews/list', async (data: string) => {
  const userId = store.getState()?.auth?.user?.vendor?.id;
  const res = await axios.get(`${VENDOR_MC_URL}/product-review/vendor/${userId}?${data}`);
  return res.data;
});

const productReviewsSlice = createSlice({
  name: 'productReviews',
  initialState,
  reducers: {
    setError: (state, action) => {
      state.showError = action.payload;
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<IState>) => {
    builder.addCase(productReviews.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(productReviews.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.done = true;
    });
    builder.addCase(productReviews.rejected, (state, action) => {
      state.loading = false;
      state.showError = true;
      state.error = 'Hata! Veri listelenemedi.';
      state.data = {} as IProductReviews;
    });
    //
  },
});
export const { setError } = productReviewsSlice.actions;
export default productReviewsSlice.reducer;
